exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td.fit{padding-left:50px;white-space:nowrap;width:1%}.table td,.table th{vertical-align:middle}.loader{margin-left:45%;border:4px solid #324851;border-right-color:#fff;border-left-color:#fff;border-radius:50%;width:30px;height:30px;-webkit-animation:spin 1s linear infinite;animation:spin 1s linear infinite}.loading-parent{position:relative}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50977037","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BookDeliveryTabComponents/BookListComponent.vue
// module id = xreM
// module chunks = 1